import { render, staticRenderFns } from "./candidate-modal-changes-history.vue?vue&type=template&id=7067963a&scoped=true&"
import script from "./candidate-modal-changes-history.vue?vue&type=script&lang=js&"
export * from "./candidate-modal-changes-history.vue?vue&type=script&lang=js&"
import style0 from "./candidate-modal-changes-history.vue?vue&type=style&index=0&id=7067963a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7067963a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7067963a')) {
      api.createRecord('7067963a', component.options)
    } else {
      api.reload('7067963a', component.options)
    }
    module.hot.accept("./candidate-modal-changes-history.vue?vue&type=template&id=7067963a&scoped=true&", function () {
      api.rerender('7067963a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/candidate-modal-components/candidate-modal-changes-history.vue"
export default component.exports